import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import Vue from "vue"

const toast = (icon, variant, title) => {
  const obj = Vue.$toast({
    component: ToastificationContent,
    props: {
      icon,
      variant,
      title,
    },
  })

  return obj
}

export default toast
